import { decode } from '@finn-no/safe-props';
import React from 'react';
import ReactDOM from 'react-dom';
import pulse from '@finn-no/pulse-sdk';
import Page, { PageProps } from './page.js';
import { TrackJS, TrackJSInstallOptions } from 'trackjs';
import i18n from './load-languages.js';

declare global {
    interface Window {
        _trackJs?: TrackJSInstallOptions;
    }
}

function getEnvironmentId(
    consentUser: ConsentUser,
): Promise<string | undefined> {
    if (consentUser.isLoggedIn) {
        return Promise.resolve(undefined);
    } else {
        return new Promise((resolve, reject) => {
            pulse.getTracker((tracker) => {
                tracker.getEnvironmentId().then(resolve).catch(reject);
            });
        });
    }
}

window.addEventListener('DOMContentLoaded', async () => {
    if (window._trackJs && !TrackJS.isInstalled()) {
        TrackJS.install(window._trackJs);
    }

    pulse.trackPageView({
        type: 'View',
        object: {
            id: 'userprofilepage:privacy:ua_pv02',
            type: 'UserProfilePage',
            name: 'Personvern',
            pageType: 'my_account',
        },
    });

    try {
        const rootPanel = document.getElementById('consent-frontpage');

        if (rootPanel) {
            const props: PageProps = decode(rootPanel.dataset.props || '');
            i18n.activate(props.locale);
            if (!props.consentUser.isLoggedIn) {
                props.environmentId = await getEnvironmentId(props.consentUser);
                console.log(`Using environmentId=${props.environmentId}`);
                if (!props.environmentId && TrackJS.isInstalled()) {
                    TrackJS.track('Missing environmentId for anonymous user');
                }
            }
            ReactDOM.hydrate(<Page {...props} i18n={i18n} />, rootPanel);
            console.log(`Hydrated consent-frontpage`);
        }
    } catch (err: unknown) {
        TrackJS.track(err as Error);
    }
});
